import { render } from "./SignInOptions.vue?vue&type=template&id=53bb2690&scoped=true&ts=true"
import script from "./SignInOptions.vue?vue&type=script&lang=ts"
export * from "./SignInOptions.vue?vue&type=script&lang=ts"

import "./SignInOptions.vue?vue&type=style&index=0&id=53bb2690&scoped=true&lang=scss"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bb2690"]])

export default __exports__